interface TabItemProps {
  title: string;
  children: React.ReactElement;
}
export const TabItem = (props: TabItemProps) => <>{props.children}</>;

export default TabItem;
